var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDirection(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    clipRule: "evenodd",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 1.5,
    viewBox: "0 0 24 25",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-85.464 -50.438)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.05759 0 0 .05759 60.108 36.624)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 440.29,
    y: 239.87,
    width: 416.74,
    height: 417.53,
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-2.4293 2.8721)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m615.92 365.39 80.368 80.367",
    fill: "none",
    stroke: "#616474",
    strokeWidth: "34px"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 -1 -1 891.52)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m615.92 365.39 80.368 80.367",
    fill: "none",
    stroke: "#616474",
    strokeWidth: "34px"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDirection);
export default __webpack_public_path__ + "static/media/direction.84c6b4c2e9433867d6007a1fd6cd5d85.svg";
export { ForwardRef as ReactComponent };